<template>
    <v-row>
        <v-col lg="9" md="11" sm="11" cols="11" class="py-2 mx-auto">
            <h1 class="font-weight-bold my-0 py-0" v-if="!busy">{{ heading }}</h1>
            <p class="pb-5" v-text="desc"></p>
            <v-row v-if="!hideFilter" align="end">
                <v-col>
                    <v-text-field
                        label="Keyword"
                        v-model="keywordFilter"
                        @change="addFilter"
                        @click:clear="clearFilter"
                        hide-details
                        clearable
                    />
                </v-col>
                <v-col>
                    <v-text-field
                        label="State"
                        v-model="stateFilter"
                        @change="addFilter"
                        @click:clear="clearFilter"
                        hide-details
                        clearable
                    />
                </v-col>
                <v-col>
                    <v-select
                        v-model="tagFilter"
                        :items="tagFilters"
                        chips
                        deletable-chips
                        hide-details
                        >
                    </v-select>
                </v-col>
            </v-row>
            <v-row id="container" class="py-3">
                <v-col
                    v-for="(item) in visibleItems"
                    :key="item.name"
                    cols="12"
                    sm="6"
                    md="4"
                    lg="4"
                    class="pa-4 pa-md-5"
                  > 
                    <v-sheet class="fill-height" color="transparent">
                        <v-lazy 
                            v-model="item.isActive"
                            :options="{threshold: .2}"
                            class="fill-height">
                            <div>
                                <card-resource :item="item" :viewName="viewName" :card-props="cardProps" />
                                <h4 class="font-weight-light text-truncate py-2" :title="item.Short">
                                    <span v-text="item.Name"></span>
                                </h4>
                            </div>
                        </v-lazy>
                    </v-sheet>
                </v-col>
            </v-row>
            <v-progress-linear
                v-if="busy" 
                indeterminate
                color="primary"
                class="my-5"
            ></v-progress-linear>
            <v-row v-if="!busy">
                <v-col class="text-center py-5">
                    
                </v-col>
            </v-row>
        </v-col>
    </v-row>
</template>
<script>
import { mapState, mapMutations } from 'vuex'
import { GET_RESOURCES_VIEW } from '@/store/action-types'
import { SET_RESOURCES_FILTER, CLEAR_RESOURCES_VIEW, SET_RESOURCES_LOADING, SET_RESOURCE_SEARCH_TAG } from '@/store/mutation-types'
import CardResource from '@/components/CardResource'

export default {
    name: 'GridResources',
    components: {
        CardResource,
    },
    props: {
        heading: String,
        desc: String,
        viewName: String,
        limit: {
            type: Number,
            default: 200,
            required: false
        },
        hideFilter: {
            type: Boolean,
            default: false,
            required: false
        },
        random: {
            type: Boolean,
            default: false,
            required: false
        },
        cardProps: {
            type: Object,
            default() {
                return {
                    cardClass: 'pa-0',
                    contain: true,
                }
            },
            required: false
        },
    },
    beforeRouteUpdate (to, from, next) {
        console.log('beforeRouteUpdate')
        next()    
    },
    data() {
        return {
            items: [],
            serverPage: 1,
            serverPageSize: 15,
            selectedItem: {},
            tagFilter: null,
            tagFilters: ['cabin','a-frame','modern'],
            stateFilter: null,
            keywordFilter: null,
        }
    },
    computed: {
        ...mapState({
            resources: state => state.resource.resourcesByView,
            // dialogDetails: state => state.resource.dialogDetails,
            filter: state => state.resource.filter,
            busy: state => state.resource.isLoading,
        }),
        visibleItems () {
            if (this.tagFilter) {
                return this.items.slice(0, this.limit).filter(i => (i.TagNames||[]).includes(this.tagFilter))
            }
            else {
                return this.items.slice(0, this.limit)
                // return this.items
            }
        },
        visibleCount () {
            return this.visibleItems.filter(p=>p.isActive).length
        },
        offset () {
            return this.items.length ? this.items[this.items.length-1].offset : 0
        },
        imgHeight () {
            switch (this.$vuetify.breakpoint.name) {
                case 'xs': return 170
                case 'sm': return 180
                case 'md': return 200
                case 'lg': return 220
                case 'xl': return 300
                default: return 190
            }
        },
    },
    methods: {
        ...mapMutations({
            setResourcesFilter: SET_RESOURCES_FILTER,
            clearResourcesView: CLEAR_RESOURCES_VIEW,
            setBusy: SET_RESOURCES_LOADING,
            setSearchTag: SET_RESOURCE_SEARCH_TAG
        }),
        async getResources() {
            // console.log('getResources with:', this.filter)
            await this.$store.dispatch(GET_RESOURCES_VIEW, {
                viewName: this.viewName,
                pageSize: this.serverPageSize,
                offset: this.offset || 0,
            })
            this.items = this.resources[this.viewName]
        },
        addFilter () {
            this.setResourcesFilter({
                State: this.stateFilter,
                Short: this.keywordFilter,
            })
        },
        clearFilter () {
            this.stateFilter = null
            this.serverPage = 1
            this.setResourcesFilter({})
        },
        shuffle(array) {
            for (let i = array.length - 1; i > 0; i--) {
                const j = Math.floor(Math.random() * (i + 1));
                [array[i], array[j]] = [array[j], array[i]];
            }
            return array
        }
    },
    mounted() {
        this.getResources()
    },
    watch: {
        visibleCount(val) {
            if (val === (this.serverPageSize * this.serverPage)) {
                //load more from server
                this.serverPage = this.serverPage + 1
                console.log('load more...', this.serverPage)
                if (!this.busy) {
                    this.getResources()
                }
            }
        },
        filter(obj) {
            if (obj && Object.keys(obj).length > 0) {
                console.log('filter...', obj)
                this.items = []
                this.serverPage = 1
            }
            this.clearResourcesView({ viewName: this.viewName })
            this.getResources()
        },
        tagFilter(val) {
            console.log('tagFilter...', val)
            this.setSearchTag(val);
            this.clearResourcesView({ viewName: this.viewName })
            this.getResources();
        },
        viewName(old, newVal) {
            if (old !== newVal) {
                this.items = []
                this.serverPage = 1
            }
            this.clearResourcesView({ viewName: this.viewName })
            this.getResources()
        }
    }
}
</script>